<script>
    export default {
        created() {
            this.selectedItem = this.params[this.type];

            if (this.selectedItem) {
                this.selected = this.selectedItem;
            }
        },
        data() {
            return {
                params: URI(window.location.href).search(true),
                url: new URL(location.href),
                selectedItem: null,
                selected: null,
            }
        },
        watch: {
            selected(value) {
                this.itemSelected(value);
            },
        },
        props: {
            title: {
                type: String
            },
            type: {
                type: String
            },
            data: {
                'default': {}
            }
        },
        computed: {
            options() {
                return _.map(this.data, (option) => {
                    return option.toString();
                });
            },
        },
        methods: {
            itemSelected(selectedItem) {
                if (selectedItem != this.selectedItem) {
                    this.applyFilter(selectedItem);
                }
            },
            applyFilter(selectedItem) {
                if (selectedItem) {
                    this.params[this.type] = selectedItem;
                } else {
                    delete this.params[this.type];
                }

                window.location.href = URI(window.location.href).search(this.params).href();
            },
        }
    }
</script>

<template>
    <div class="form-group">
        <h5>{{ title }}</h5>
        <v-select
                :name="title"
                v-model="selected"
                :options="options"
                :value="selectedItem"
        ></v-select>
    </div>
</template>
